// Local staff preview only. OCR confidence/verdict is not ground truth.
// Distinguish independent recognition, scaffolded tracing and a gentle practice stop.
export default function handwritingProgress(game, events) {
  let cursor = 0, lastVerdict = null, lastAssisted = false, lastInput = null, attempts = 0;
  let manual = 0, independent = 0, assistedAccepted = 0, slotAccepted = 0, assistedSlotAccepted = 0, assistedFailures = 0;
  let stoppedEarly = false, stoppedOnItemId = null;
  const diagnostics = { correct: 0, retry: 0, uncertain: 0, error: 0 };
  const slotDiagnostics = { correct: 0, retry: 0 };
  const outcomes = [];
  for (const event of events) {
    if (stoppedEarly || cursor >= game.items.length || event.item_id !== game.items[cursor].id) {
      throw new Error('Yazma önizlemesi sırası geçersiz.');
    }
    if (((event.kind === 'ocr_result' && Object.hasOwn(diagnostics, event.verdict))
      || (event.kind === 'letter_result' && Object.hasOwn(slotDiagnostics, event.verdict)))
      && (event.assisted === undefined || typeof event.assisted === 'boolean')) {
      lastVerdict = event.verdict;
      lastInput = event.kind;
      lastAssisted = event.assisted === true;
      attempts += 1;
      if (event.kind === 'ocr_result') diagnostics[event.verdict] += 1;
      else slotDiagnostics[event.verdict] += 1;
      if (lastAssisted && ['retry', 'uncertain'].includes(event.verdict)) assistedFailures += 1;
    } else if (event.kind === 'continue' && attempts > 0 && typeof event.manual === 'boolean') {
      if (!event.manual && lastVerdict !== 'correct') throw new Error('Belirsiz OCR sonucu başarı sayılamaz.');
      manual += Number(event.manual);
      independent += Number(!event.manual && !lastAssisted && lastInput === 'ocr_result');
      assistedAccepted += Number(!event.manual && lastAssisted && lastInput === 'ocr_result');
      slotAccepted += Number(!event.manual && !lastAssisted && lastInput === 'letter_result');
      assistedSlotAccepted += Number(!event.manual && lastAssisted && lastInput === 'letter_result');
      outcomes.push({ item_id: event.item_id, manual: event.manual,
        assisted: lastAssisted, ...(lastInput === 'ocr_result'
          ? { ocr_verdict: lastVerdict, input_mode: 'free_hand' }
          : { letter_verdict: lastVerdict, input_mode: 'letter_slots' }) });
      cursor += 1;
      attempts = 0;
      assistedFailures = 0;
      lastVerdict = null;
      lastAssisted = false;
      lastInput = null;
    } else if (event.kind === 'end_practice' && lastAssisted && assistedFailures >= 2
      && ['retry', 'uncertain'].includes(lastVerdict)) {
      stoppedEarly = true;
      stoppedOnItemId = event.item_id;
      outcomes.push({ item_id: event.item_id, practice_stopped: true, assisted: true,
        ...(lastInput === 'ocr_result' ? { ocr_verdict: lastVerdict, input_mode: 'free_hand' }
          : { letter_verdict: lastVerdict, input_mode: 'letter_slots' }) });
    } else throw new Error('Yazma önizlemesi olayı geçersiz.');
  }
  const completed = stoppedEarly || cursor === game.items.length;
  return { completed, outcomes, summary: {
    game_id: game.game_id, completed, measurement_type: game.student_dictation ? 'LETTER_DICTATION' : 'UNMEASURED_PREVIEW',
    target_count: game.items.length, preview_completed_count: cursor,
    practice_ended_early: stoppedEarly, stopped_on_item_id: stoppedOnItemId,
    ocr_accepted_count: independent, assisted_ocr_accepted_count: assistedAccepted,
    manual_continue_count: manual, ocr_diagnostics: diagnostics,
    letter_slots_accepted_count: slotAccepted, assisted_letter_slots_count: assistedSlotAccepted,
    letter_slots_diagnostics: slotDiagnostics,
  } };
}
